<template> 
  <div> 
     <div class="d-flex flex-column flex-root"> 
			<div class="d-flex flex-column flex-center flex-column-fluid">
				<div class="d-flex flex-column flex-center text-center p-10">        
					<div class="card card-flush w-lg-650px py-5">
						<div class="card-body py-15 py-lg-20">
							<h1 class="fw-bolder fs-2hx text-gray-900 mb-4">
								{{ $t('thank_you') }} 
							</h1>
							<div class="fw-semibold fs-6 text-gray-500 mb-7">
								{{ $t('we_have_now') }} 
							</div>
							<div class="mb-3">
								<img src="assets/theme/media/illustrations/sigma-1/2.png" class="mw-100 mh-300px theme-light-show" alt="">
								<img src="assets/theme/media/illustrations/sigma-1/2-dark.png" class="mw-100 mh-300px theme-dark-show" alt="">
							</div> 
						</div>
					</div>   
				</div>
			</div>
		</div>
  </div>  
</template>

<script>
import axios from "axios"; 
export default {
  name: "UpgradeSuccess",
  components: {},
  data() {
    return {
      userData: this.$getUser()
    };
  },
  computed: {},
  methods: { 
    getData() {
        const parameters = {
          session_id: this.$getUser().session_id,
          lang: localStorage.getItem('locale') || this.$i18n.locale || 'en'
        };
        axios.post('api/Payment/Control', parameters, {'Content-Type': 'application/json'}) 
        .then((response) => {
          if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
            setTimeout(() => {
              this.$signOutWithTimer(this.$t('we-received-your-payment'), this.$t('were-glad-to-inform-you-that-we-have-confirmed-you'));
            }, 3000);
          }
          else{
            this.$signOutWithTimer(this.$t('session-terminated'), this.$t('a-problem-occured-while-activating-your-licence-le'));
          }
        })
        .catch((error) => {
            console.error(error);
        });  
    }  
  },
created(){
    this.getData();
}
};
</script>